module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch010"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“LIEUTENANT WORF (played by Michael Dorn): A Klingon, the only one to have graduated so far from Starfleet Academy, Worf is in charge of security for the "), _c('em', [_vm._v("U.S.S. Enterprise")]), _vm._v(", a rather appropriate position for one from a race which considers military expertise the highest of all virtues. As a child, Worf lost his parents during a Romulan attack on the Federation Outpost at Khitomer. Worf was the only Klingon survivor, and was adopted by a human Starfleet family. Although his emotions and some of his values are Klingon, Worf is totally loyal to Picard and the "), _c('em', [_vm._v("Enterprise")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In addition to his expertise on starship security, Worf is also of value to Picard as an expert on armaments of all types….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Worf has little sense of humor, at least none that humans can translate. His speech pattern, however, can provide humor to us. He speaks in short declarative statements. When on a world featuring lovely half-naked women (‘Justice’), he summed up his impressions with, ‘Nice planet!’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’/directors’ guide ’88–89, second-season revision")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“COUNSELOR DEANNA TROI (played by Marina Sirtis): An attractive and very witty Starfleet professional, she is the starship’s Counselor, a position of vital importance on space vessels of the 24th century; the success of a starship’s mission depends as much on efficiently functioning human relationships as on the vessel’s mechanisms and circuitry. Troi is a master in human and alien psychology, also Starfleet-trained as a bridge officer. Her mother was a Betazed alien and she has inherited a form of telepathic ability that allows her to ‘feel’ the emotions of others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Troi and Riker are old friends who had a tempestuous relationship sometime in the past. Somehow it didn’t work and, with both on the same vessel, now that fire is only embers, a warm and comfortable friendship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’ guide, March 23, 1987; and the writers’/directors’ guide ’88–89, second-season revision")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-01.jpg",
      "width": "450px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11193a57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch010.vue
// module id = 102
// module chunks = 0